export const normalizeWhatsAppPhoneInput = (value) =>
  String(value || "").trim().replace(/[\s().-]/g, "");

export const isValidOptionalWhatsAppPhone = (value) => {
  const normalized = normalizeWhatsAppPhoneInput(value);
  return !normalized || /^\+[1-9]\d{6,14}$/.test(normalized);
};

export const WHATSAPP_PHONE_VALIDATION_MESSAGE =
  "Saisissez l’indicatif international, par exemple +226 70 00 00 00.";
